export default __webpack_public_path__ + "static/media/lp-02-trainer-desktop.1409a61b.png";